import { Box, Container, styled } from '@mui/material';
import { SectionErrorBoundary } from 'src/components/ErrorBoundary/SectionErrorBoundary';
import { useSearchParams } from 'react-router-dom';
import TabComponent from 'src/components/Tab/TabComponent';
import { LIS_ACTIVITIES_TABS, TypeActivitiesTab } from 'src/features/Activities/config';
import MyActivities from 'src/features/Activities/MyActivities';
import TeamManagement from 'src/features/Activities/TeamManagement';

const StyledContainer = styled(Container)(({ theme }) => ({
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(7),
}));

const Activities = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const tabParam = searchParams.get('tab');
  const selectedTab = Object.values(TypeActivitiesTab).includes(tabParam as TypeActivitiesTab)
    ? (tabParam as TypeActivitiesTab)
    : TypeActivitiesTab.MY_ACTIVITIES;

  const renderForm = () => {
    switch (selectedTab) {
      case TypeActivitiesTab.MY_ACTIVITIES:
        return <MyActivities />;
      case TypeActivitiesTab.TEAM_ACTIVITIES:
        return <MyActivities />;
      case TypeActivitiesTab.TEAM_MANAGEMENT:
        return <TeamManagement />;
      default:
        return <MyActivities />;
    }
  };

  return (
    <StyledContainer maxWidth={'xl'}>
      <TabComponent
        selected={selectedTab}
        handleChange={(_, tab) => setSearchParams({ tab })}
        tabs={LIS_ACTIVITIES_TABS}
      />
      <Box mt={3} />
      <SectionErrorBoundary resetKey={selectedTab} sectionName={`Activities-${selectedTab}`}>
        {renderForm()}
      </SectionErrorBoundary>
    </StyledContainer>
  );
};

export default Activities;
